<template>
    <div>
        <Toolbar>
            <BackButton :to="__('general.coupons')"
                        :href="$route('subscriptions.coupons')"
                        :prevent-leave="coupon.isDirty"
                        :prevent-leave-text="abortText"
                        :disabled="coupon.processing"
                        ref="backButton"
            />
        </Toolbar>

        <Card>
            <template v-slot:title>
                {{ __('actions.create_thing', {thing: __('general.coupon')}) }}
            </template>
            <template v-slot:description>
                Erstellen Sie einen neuen Gutschein.
            </template>

            <!-- FORM ELEMENTS -->
            <CouponForm v-model="coupon"/>

            <template v-slot:footer>
                <div class="d-flex flex-row">
                    <div class="flex-grow-1">
                        <button class="btn btn-secondary" @click="abort" :disabled="coupon.processing">
                            <i class="fas fa-times mr-1"/>
                            {{ __('actions.abort') }}
                        </button>
                    </div>
                    <div>
                        <button class="btn btn-primary" @click="create" :disabled="coupon.processing">
                            <ButtonSpinner :show="coupon.processing"/>
                            <i v-show="!coupon.processing" class="fas fa-save mr-1"/>
                            {{ __('actions.create') }}
                        </button>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import CouponForm from "@components/Subscriptions/Coupons/CouponForm.vue";
import Card from "@components/Cards/Card.vue";
import BackButton from "@components/BackButton.vue";
import { Link } from '@inertiajs/vue2';
import ButtonSpinner from "@components/ButtonSpinner.vue";
import Toolbar from "@components/Toolbar.vue";

export default {
    components: {Toolbar, ButtonSpinner, BackButton, Card, CouponForm, Link},

    data() {
        return {
            abortText: 'Cancel creating coupon?',
            coupon: this.$inertia.form({
                name: null,
                type: 'percent',
                value: null,
                code: null,
                months_discounted: null,
                max_redemptions: null,
                expires_at: null
            })
        }
    },

    methods: {
        abort() {
            this.$refs.backButton.$el.click();
        },

        create() {
            this.coupon.put(this.$route('subscriptions.coupons.create'))
        }
    }
}
</script>
